import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  CircularProgress,
  Backdrop,
  ClickAwayListener,
  Divider,
  Grid,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';

import Page from 'components/Page';
import CTMap from 'components/CTMap';

import * as OTROrderAction from 'actions/otr/otr-order-action';
import { getOrderTimingStats, getInvoiceByOrderId, getFilesByOrderId, } from 'services/otr/otr-order-service.js';
import { bindActionCreators } from 'redux';
import { filterOrderDataByTab } from 'utils/filter';
import { formatCurrency } from 'utils/formatter.js';
import { Validate } from 'utils/Validator';

import 'rsuite/dist/rsuite.min.css';
import '../../../styles/rsuite-component.css';
import ToastHandler from 'components/Toast-Handler/toast-handler';

import PageHeader from 'global/PageHeader';
import Notificationbar from 'global/Notificationbar';
import { ArrowDropDown, CloseOutlined, ImportExportOutlined } from '@mui/icons-material';
import Searchbar from 'global/Searchbar';
import DataDialog from 'components/dialogs/DataDialog';
import { getOrderNotifications } from 'services/notification-service';
import NotificationDialog from 'components/dialogs/NotificationDialog';
import OrderStats from '../order-stats';
import InvoiceModal from '../../Accounting/invoice-modal';
import FilesModal from 'components/files-modal';
import ConfirmationDialog from 'components/dialogs/ConfirmationDialog';
import { Calendar } from 'rsuite';
import { SwimlaneHeader } from 'styles/GlobalStyle';

import OTRLoadForm from '../forms/otr-load-form';

import { LOAD_TYPE_MAPPING } from 'utils/constant';
import { tokens } from 'theme/tokens';
import DispatchGridView from '../views/grid-view';
import FormDrawer from 'components/FormDrawer';
import LoadDetail from '../views/load-detail';
import ContentDrawer from 'components/ContentDrawer';
import DispatchTableView from '../views/table-view';

const PAGESIZE = 1000;
const LOCALE = 'USD';
const OTR_STATUS = ['NEW', 'PROGRESS', 'DELIVERED', 'COMPLETED'];

const DISPATCH_MODE = ['TODAY', 'ALL ORDERS', 'NO APPOINTMENT ORDERS'];
const SEARCH_FIELDS = [
  { 'name': 'OrderId', 'label': 'Order Id', 'type': 'text' },
  { 'name': 'Terminal/Shipper', 'label': 'Terminal/Shipper', 'type': 'text' },
  { 'name': 'Broker', 'label': 'Broker', 'fieldType': 'text' },
  { 'name': 'Broker W/O Number', 'label': 'Broker Load Num.', 'type': 'text' },
  { 'name': 'Truck Number', 'label': 'Truck Number', 'type': 'text' },
];

const OTRDispatch = (props) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const TAB_COLORS = {
    INFO: colors.info.main,
    WARNING: colors.warning.main,
    ERROR: colors.error.main,
    SUCCESS: colors.success.main,
  };

  const getTabColor = (type) => TAB_COLORS[type] || colors.info.main;
  const initState = {
    originCount: 1,
    destinationCount: 1,
    summary: {
      brokerId: null,
      loadType: '',
      broker: {},
      brokerOrderNumber: '',
      lineHaulCharges: '',
      fuelCharges: '',
      fuelChargesType: '$',
      loadDescription: '',
      weight: '',
      weightUnit: 'lbs',
      length: '',
      lengthUnit: 'feet',
      distance: '',
      distanceUnit: 'miles',
      duration: '',
      expenses: [],
      orderTotal: '',
      notes: '',
      palletQty: '',
      temperature: '',
      tempUnit: 'C', // degree F or degree C      
    },
    expense: {
      id: '',
      category: '',
      categoryDescription: '',
      name: '',
      billableAmount: '',
      companyShare: '',
      driverShare: '',
      isPerDay: false,
      expenseType: 'BILLABLE',
    },
    origin: [{
      id: null,
      name: '',
      appointment: new Date(),
      requiresAppointment: false, // We don't need another boolean. If user enters the data in this field it means we need open appointment. 
      contactPerson: '',
      contactPhone: '',
      contactEmail: '',
      puNumber: '',
      notes: '',
      address: {
        street: '',
        city: '',
        state: '',
        zipcode: '',
        address: '',
        country: '',
      }
    }],
    destination: [{
      id: null,
      name: '',
      appointment: new Date(),
      requiresAppointment: false, // We don't need another boolean. If user enters the data in this field it means we need open appointment. 
      contactPerson: '',
      contactPhone: '',
      contactEmail: '',
      deliveryNumber: '',
      notes: '',
      address: {
        street: '',
        city: '',
        state: '',
        zipcode: '',
        address: '',
        country: '',
      }
    }],
    equipment: {
      equipmentId: null,
      equipmentType: '',
      equipmentConfiguration: null,
      truckId: null,
      truck: '',
      startMileage: '',
      endMileage: '',
      trailerNumber: '',
      trailerLicense: '',
      trailerNumberHook: '',
      trailerLicenseHook: '',
      weightUnit: 'lbs',
      lengthUnit: 'feet',
    }
  };
  const [order, setOrder] = useState(initState);
  const [action, setAction] = useState('Save');
  const [dispatchMode, setDispatchMode] = useState('TODAY');
  const [viewMode, setViewMode] = useState('GRID'); //other view is TABLE
  const [isMapVisible, setMapVisibility] = useState(false);


  /* Dispatch Mode Logic */
  const [isDispatchModeMenuOpen, setDispatchModeMenuOpen] = useState(false);
  const [anchorRef, setAnchorRef] = useState(null);
  const [dispatchDate, setDispatchDate] = useState(new Date());

  /* Search State */
  const [isSearchEnabled, setSearchEnable] = useState(false);
  const [searchParameters, setSearchParameters] = useState({});

  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(1000);
  const [orderCount, setOrderCount] = useState(500);
  const [nextPageLoading, setNextPageLoading] = useState(false);

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [orderStats, setOrderStats] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const [originMarkers, setOriginMarker] = useState([]);
  const [destinationMarkers, setDestinationMarker] = useState([]);

  /* DIALOGS */
  const [isOrderFormDialogOpen, setOrderFormDialogOpen] = useState(false);
  const [isOrderDetailDialogOpen, setOrderDetailDialog] = useState(false);
  const [isOrderStatsDialogOpen, setOrderStatsDialog] = useState(false);
  const [isOrderHistoryDialogOpen, setOrderHistoryDialog] = useState(false);
  const [isDeleteOrderDialogOpen, setDeleteOrderDialog] = useState(false);
  const [isOrderMapDialogOpen, setMapDialog] = useState(false);
  const [isFileUploadDialogOpen, setFileUploadDialog] = useState(false);
  const [isInvoiceDialogOpen, setInvoiceDialog] = useState(false);
  const [isAdvanceSearchDialogOpen, setAdvanceSearchDialog] = useState(false);
  const [isNotificationDialogOpen, setNotificationDialog] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  const fileModalChildRef = useRef(null);

  useEffect(() => {
    if (dispatchMode == 'ALL ORDERS') {
      dispatch(OTROrderAction.listOrders(null, null, null, pageNumber, PAGESIZE)); // Get All Orders
    } else if (dispatchMode === 'NO APPOINTMENT ORDERS') {
      dispatch(OTROrderAction.listOrders('NO', null, null, pageNumber, PAGESIZE)); // Get No Appointment Orders
    } else {
      const startDate = new Date(dispatchDate.setHours(0, 0, 0, 0)); // dispatchDate by default is Today's date
      const endDate = new Date(dispatchDate.setHours(23, 59, 59, 999));
      const startDateISO = startDate.toISOString();
      const endDateISO = endDate.toISOString();
      dispatch(OTROrderAction.listOrders('YES', startDateISO, endDateISO, pageNumber, PAGESIZE)); // Get Appointment orders By Date
    }
    // return dispatch(OTROrderAction.fetchDataPeriodically());
  }, [dispatchMode, dispatchDate]);

  /* When Dispatch Mode changes or date changes we need to 
  make API call to pull orders 
  */

  /* Dispatch mode menu */
  const handleDispatchModeChange = (evt) => {
    const mode = evt.currentTarget.textContent;
    if (mode === 'TODAY') {
      setDispatchDate(new Date()); //reset to today's date.
    }
    setDispatchMode(mode);
    setDispatchModeMenuOpen(false);
  };

  const handleDateChange = (evt) => {
    const dd = new Date(evt);
    const customDate = new Date(dd.setMinutes(dd.getMinutes() + dd.getTimezoneOffset())); //Need this for firefox. otherwise for chrome we can use datetime-local.
    setDispatchDate(customDate);
    setDispatchMode(customDate.toDateString()); // Show user which date they have selected.
    setDispatchModeMenuOpen(false);
  };

  /* Table or Grid View */
  const toggleViewMode = () => {
    const newViewMode = viewMode === 'GRID' ? 'TABLE' : 'GRID';
    setViewMode(newViewMode);
  };

  const toggleLocationMap = () => {
    setMapVisibility(!isMapVisible);
  };

  const addOrder = () => {
    setAction('Save');
    setOrderFormDialogOpen(true);
  };

  const editOrder = (row) => {
    const dispatchOrder = Validate.parseOTRDispatchOrder(row);
    setOrder(dispatchOrder);
    setAction('Update');
    setOrderFormDialogOpen(true);
  };

  const processOrderPersist = (order) => {
    const { summary, origin, destination, equipment } = order;

    // TODO: Add the Order Creation Date
    // Load Type Mapping
    summary.loadType = LOAD_TYPE_MAPPING[summary.loadType];
    summary.brokerId = summary.broker.id;
    summary.broker = summary.broker.data;
    const temp = summary.expenses.map(exp => ({ ...exp, category: exp.category, categoryDescription: exp.categoryDescription }));
    summary.expenses = temp;
    const origins = origin.map(o => { return { ...o, id: o.name.id, name: o.name.value, address: o.name.data.address }; });
    const destinations = destination.map(o => { return { ...o, id: o.name.id, name: o.name.value, address: o.name.data.address }; });
    equipment.truckId = equipment.truck.id;
    equipment.truck = equipment.truck.value;
    // if(equipment.trailerNumber) {
    //   equipment.trailerNumber = equipment.trailerNumber.value;
    // }
    const dispatchOrder = Object.create(null);
    dispatchOrder.orderCreateDate = new Date();
    dispatchOrder.summary = summary;
    dispatchOrder.originLocations = origins;
    dispatchOrder.destinationLocations = destinations;
    dispatchOrder.equipment = equipment;

    /* Using Radar APIs for distance calculation */

    if (action === 'Save') {
      dispatch(OTROrderAction.save(dispatchOrder));
    } else {
      dispatchOrder.id = order.id;
      dispatch(OTROrderAction.update(dispatchOrder));
    }
  };

  const toggleDeleteOrder = (order) => {
    setSelectedOrder(order);
    setDeleteOrderDialog(!isDeleteOrderDialogOpen);
  };
  const processDeleteOrder = () => {
    const orderId = selectedOrder.id;
    dispatch(OTROrderAction.deleteOrder(orderId));
  };

  const closeDeleteOrderDialog = () => {
    dispatch(OTROrderAction.reset('RESET_TOAST_STATE'));
    setDeleteOrderDialog(false);
  };

  const toggleOrderDetail = (order) => {
    props.setActiveOrder(order); // similar to props.getOrderById()
    setSelectedOrder(order);
    setOrderDetailDialog(!isOrderDetailDialogOpen);
  };

  const closeFormDialog = () => {
    dispatch(OTROrderAction.reset('RESET_TOAST_STATE'));
    setOrder(initState);
    setOrderFormDialogOpen(false);
  };

  /* Order Properties */
  const processOrderStats = (order) => {
    if (isOrderStatsDialogOpen) {
      setSelectedOrder(null);
      setOrderStats([]);
      setOrderStatsDialog(false);
    } else {
      getOrderTimingStats(order.id).then((res) => {
        setSelectedOrder(order);
        setOrderStats(res.data);
        setOrderStatsDialog(true);
      });
    }
  };

  const processFileUpload = (order) => {
    if (isFileUploadDialogOpen) {
      setFileUploadDialog(false);
      setSelectedOrder(null);
    } else {
      setSelectedOrder(order);
      getFilesByOrderId(order.id)
        .then((res) => {
          if (res.status === 200 && res.data) {
            // res.data
            fileModalChildRef.current.onInit(res.data);
          }
        })
        .catch((e) => {
          // pass error
          fileModalChildRef.current.onInit(null, e);
        });
      setFileUploadDialog(true);
    }
  };

  const downloadOrderCSV = () => {
    const filename = 'orders.csv';
    const { orders } = props;

    const formattedOrders = [];
    const header = ['OrderId', 'OrderType', 'Broker', 'Broker Order Number', 'Rate', 'FSC', 'Status', 'Container Num', 'Line', 'Chassis Number', 'Company', 'CompleteDate', 'Payment Status', 'Notes'];
    const subHeader = ['', 'LegId', 'Origin', 'Destination', 'Leg Status', 'Driver', 'Driver Rate'];

    formattedOrders.push(header);

    orders.forEach(function (order) {
      const { legs, broker, container, chassis } = order;
      let containerNumber = container.deliveryContainerNumber;
      if (order.orderType === 'PICKUP') {
        containerNumber = container.pickupContainerNumber;
      }

      let arr = [order.displayOrderId, order.orderType, broker.name, order.brokerOrderNumber, formatCurrency(order.orderRate), formatCurrency(order.fuelCharges) || 0.0, order.status, containerNumber, container.line, chassis.chassisNumber, chassis.company, order.orderCompleteDate, order.paymentStatus, order.notes];
      formattedOrders.push(arr);
      formattedOrders.push(['']);
      formattedOrders.push(subHeader);
      legs.forEach(function (leg) {
        const origins = leg.origins.map(lo => lo.name);
        const destinations = [];
        leg.destinations.forEach(ld => {
          if (ld.active)
            destinations.push(ld.name);
        });
        const driverName = leg.driver ? leg.driver.fullName : 'N.A';
        const driverRate = leg.driver ? leg.driver.rate : 'N.A';
        arr = ['', leg.id, origins, destinations, leg.status, driverName, driverRate];
        formattedOrders.push(arr);
      });
      formattedOrders.push(['']);
      formattedOrders.push(['']);
    });
    let csvContent = 'data:text/csv;charset=utf-8,';
    formattedOrders.forEach(function (rowArray) {
      let row = rowArray.join(',');
      csvContent += row + '\r\n';
    });
    const data = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    link.click();
  };

  const countOrdersByStatus = (data) => {
    const result = {};
    ['NEW', 'OPEN', 'PROGRESS', 'YARD', 'DELIVERED', 'COMPLETED'].forEach(status => {
      if (status === 'YARD') {
        const YARD = ['YARD_IN', 'YARD_PULL', 'DRYRUN'];
        result[status] = data.filter(d => YARD.includes(d.status)).length;
      } else if (status === 'PROGRESS') {
        const PROGRESS = ['PROGRESS', 'COVERED'];
        result[status] = data.filter(d => PROGRESS.includes(d.status)).length;
      } else {
        result[status] = data.filter(d => d.status === status).length;
      }
    });
    return result;
  };

  /* Search */
  /* 
    1. User click on search icon to call executeSearch function.
    2. If status is 200, we will display the search results.
    3. A Chip with onDelete property will be created based on {key:value} in the search Parameters
  */
  const toggleAdvanceSearchDialog = () => {
    setAdvanceSearchDialog(!isAdvanceSearchDialogOpen);
  };

  const handleSearchFieldChange = (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;
    const param = {};
    param[`${name}`] = value.trim();
    setSearchParameters(Object.assign(searchParameters, param));
  };

  /* Execute Search and also save state of the search variables */
  const executeSearch = (searchParameters) => {
    if (searchParameters && Object.entries(searchParameters).length > 0) {
      const params = {
        searchParam: Object.entries(searchParameters).map(([k, v]) => ({ 'label': k, 'value': v }))
      };
      setSearchEnable(true);
      setSearchParameters(searchParameters);
      setAdvanceSearchDialog(false);
      props.search(params);
    } else {
      setSearchEnable(false);
      setSearchParameters({});
      setAdvanceSearchDialog(false);

    }
  };

  /* Create Search Chip */
  const createSearchChip = () => {
    const kvpair = Object.entries(searchParameters).map(([k, v]) => ({ 'key': k, 'value': v }));
    const chips = kvpair.map(item => {
      return <Chip key={item.key}
        label={item.value}
        onDelete={(evt) => deleteSearchChip(evt, item.key)}
        color='secondary'
        size='small'
        style={{ marginRight: 5 }}
      />;
    });
    return chips;
  };
  /* Delete Search Chip and execute Search */
  const deleteSearchChip = (evt, key) => {
    clearSearchField(evt, key);
    // Execute search on remaining search items if any.
    executeSearch(searchParameters);
  };

  /* 
  Clear Search Fields - No need to perform search, because user has been given Search Button.
  */
  const clearSearchField = (evt, fieldName) => {
    const params = searchParameters;
    if (params[fieldName]) {
      delete params[fieldName];
      // We need to clear this filtered searchOption from the searchParameters and input box.
      Array.from(document.querySelectorAll('input')).forEach(input => {
        if (input.name === fieldName) //true
          input.value = null;
      });
      setSearchParameters(params);
    }
  };

  // Check the path to render the component
  const { orders, searched, activeOrder, isProcessing, toast } = props;

  const otrLoads = isSearchEnabled ? searched : orders;
  const origins = [];
  const destinations = [];
  otrLoads.map(load => {
    if (load.legs && load.legs.length > 0) {
      const count = load.legs.length;
      const firstLeg = load.legs[count - 1];
      firstLeg.origins.map(loc => origins.push(loc));
      firstLeg.destinations.map(loc => destinations.push(loc));
    }
  });
  const orderCountByStatus = countOrdersByStatus(otrLoads);
  return (
    <Page
      title='Orders'
    >
      <Box display={'flex'} justifyContent={'space-between'}>
        <PageHeader
          title='ORDERS'
          subTitle={'Manage Your OTR Dispatch'}
        />
        <Searchbar
          searchType='ADVANCED'
          isAdvanceSearchDialogOpen={isAdvanceSearchDialogOpen}
          searchParameters={searchParameters}
          fnSearchMenuHandler={toggleAdvanceSearchDialog}
        >
          <Grid container spacing={2}>
            {SEARCH_FIELDS.map(field => {
              return (
                <Grid size={{ xs: 6, sm: 4 }} key={field.name}>
                  <TextField
                    key={field.name}
                    label={field.label}
                    variant='outlined'
                    name={field.name}
                    type={field.type}
                    margin='none'
                    size='small'
                    fullWidth={true}
                    onChange={evt => handleSearchFieldChange(evt)}
                    InputProps={{
                      endAdornment: (<IconButton
                        name={field.name}
                        onClick={(evt) => clearSearchField(evt, field.name)}
                        size="large">
                        <CloseOutlined fontSize='small' />
                      </IconButton>
                      )
                    }}
                  />
                </Grid>
              );
            })
            }
          </Grid>
          <Box
            display='flex'
            justifyContent='flex-end'
            p={2}
          >
            <Button
              variant='contained'
              color='primary'
              onClick={() => executeSearch(searchParameters)}
            >
              Search
            </Button>
          </Box>
        </Searchbar>
        <Notificationbar />
      </Box>
      <Box
        m='20px 0 0 0'
        height='75vh'
      >
        <Box style={{ margin: '10px 0 10px' }}>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Button
              variant='contained'
              color='primary'
              onClick={addOrder}
            >
              {'New Order'}
            </Button>
            {isSearchEnabled &&
              <Box>
                <Box flex={1}>
                  {createSearchChip()}
                </Box>
                <Typography variant='caption'
                  sx={{
                    letterSpacing: 1,
                    color: '#667085',
                    textTransform: 'uppercase',
                    marginBottom: '2px',
                    textAlign: 'center',
                  }}
                >
                  {`${searched.length} records found`}
                </Typography>
              </Box>
            }
            <ButtonGroup size='small' variant='outlined' color='secondary' aria-label='split button'>
              <Button disabled>{dispatchMode}</Button>
              <Button
                onClick={(evt) => {
                  setDispatchModeMenuOpen(!isDispatchModeMenuOpen);
                  setAnchorRef(evt.currentTarget);
                }}
              >
                <ArrowDropDown />
              </Button>
              <Button onClick={downloadOrderCSV}><ImportExportOutlined /> </Button>
              <Button onClick={toggleViewMode}>
                {'CHANGE VIEW'}
              </Button>
              {/* <Button onClick={() => {setMapDialog(true)}}>
                {'VIEW MAP'}
              </Button>                 */}
            </ButtonGroup>
            <Popper
              open={isDispatchModeMenuOpen}
              anchorEl={anchorRef}
              modifiers={{
                arrow: {
                  enabled: true,
                  element: anchorRef
                }
              }}
              transition disablePortal style={{ zIndex: 1500 }}>
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                  }}
                >
                  <Paper elevation={2}>
                    <ClickAwayListener onClickAway={() => setDispatchModeMenuOpen(false)}>
                      <MenuList id='split-button-menu'>
                        {DISPATCH_MODE.map((option) => (
                          <>
                            <MenuItem
                              key={option}
                              onClick={(event) => handleDispatchModeChange(event)}
                            >
                              <Typography variant='body1' style={{ letterSpacing: 1 }}>{option}</Typography>
                            </MenuItem>
                            <Divider />
                          </>
                        ))}
                        <Divider />
                        <Calendar
                          compact
                          onSelect={handleDateChange}
                          style={{ width: 240 }}
                          value={dispatchDate}
                        />
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Box>
          {isProcessing && <Backdrop className='backDrop' style={{ zIndex: 10000000 }}
            sx={{ color: '#fff' }}
            open={true}>
            <CircularProgress style={{ margin: '0px 50%', display: 'flex' }} />
          </Backdrop>}
          {toast ? <ToastHandler toast={toast} type={toast.type} /> : null}
        </Box>
        {viewMode === 'GRID' ?
          <Grid container spacing={1}>
            {OTR_STATUS.map((status, idx) =>
              <Grid key={`${idx}-${status}`} style={{ minWidth: '20%' }} size={{ xs: 12, sm: 5, md: 3, lg: 2 }}>
                <SwimlaneHeader
                  variant='subtitle2'
                  style={{ color: getTabColor(status), textAlign: 'center' }}
                >
                  {status} ({orderCountByStatus[status]})
                </SwimlaneHeader>
                <DispatchGridView
                  orders={filterOrderDataByTab(otrLoads, status)}
                  transportationMode={'OTR'}
                  fnViewOrderHandler={toggleOrderDetail}
                  fnEditOrderHandler={editOrder}
                  fnDeleteOrderHandler={toggleDeleteOrder}
                  fnOrderStatsHandler={processOrderStats}
                  fnFileUploadHandler={processFileUpload}
                />
              </Grid>
            )}
          </Grid> :
          <DispatchTableView
            orders={otrLoads}
            transportationMode={'OTR'}
            fnViewOrderHandler={toggleOrderDetail}
            fnEditOrderHandler={editOrder}
            fnDeleteOrderHandler={toggleDeleteOrder}
            fnOrderStatsHandler={processOrderStats}
            fnFileUploadHandler={processFileUpload}
          />
        }
      </Box>
      {/* MAP DIALOG */}
      <DataDialog
        open={isOrderMapDialogOpen}
        width={'lg'}
        onCloseHandler={() => setMapDialog(false)}
      >
        <Box width={'1250px'} height={'450px'}>
          <CTMap
            origins={origins}
            destinations={destinations}
          />
        </Box>
      </DataDialog>
      {/* ORDER DETAIL DIALOG */}
      <ContentDrawer
        open={isOrderDetailDialogOpen}
        title='Load Detail'
        isProcessing={isProcessing}
        toast={toast}
        handleClose={() => toggleOrderDetail()}
      >
        <LoadDetail
          transportationMode='OTR'
          initialOrder={selectedOrder || activeOrder}
        />
      </ContentDrawer>
      {/* ORDER FORM DIALOG */}
      <FormDrawer
        open={isOrderFormDialogOpen}
        title={'Create Order'}
        toast={toast}
        isProcessing={isProcessing}
        handleClose={closeFormDialog}
      >
        <OTRLoadForm
          isEdit={action === 'Update'}
          orderForm={order}
          formAction={action}
          tabIndex={0}
          saveFormHandler={(order) => processOrderPersist(order)}
          updateFormHandler={(order) => processOrderPersist(order)}
          cancelDialogHandler={closeFormDialog}
        />
      </FormDrawer>
      {/* ORDER STATS DIALOG */}
      <DataDialog
        open={isOrderStatsDialogOpen}
        title={'Order Stats'}
        width={'md'}
        onCloseHandler={() => setOrderStatsDialog(false)}
      >
        <OrderStats
          title={'Order Stats'}
          orderStats={orderStats}
        />
      </DataDialog>
      {/* ORDER HISTORY DIALOG */}
      <DataDialog
        open={isOrderHistoryDialogOpen}
        title={'Order History'}
        width={'md'}
        onCloseHandler={() => setOrderHistoryDialog(false)}
      >
        <OrderStats
          title={'Order History'}
          orderHistory={orderHistory}
        />
      </DataDialog>
      {/* INVOICE DIALOG */}
      <DataDialog
        open={isInvoiceDialogOpen}
        title={'Order Invoice'}
        width={'md'}
        onCloseHandler={() => setInvoiceDialog(false)}
      >
        <InvoiceModal
          invoice={invoice || null}
        />
      </DataDialog>
      {/* NOTIFICATION DIALOG */}
      <NotificationDialog
        open={isNotificationDialogOpen}
        title={'Information'}
        width={'md'}
        onCloseHandler={() => setNotificationDialog(false)}
      >
        <Typography variant='h6'>{notificationMessage}</Typography>
      </NotificationDialog>
      <DataDialog
        open={isFileUploadDialogOpen}
        title={'Upload Documents'}
        width={'md'}
        onCloseHandler={() => setFileUploadDialog(false)}
      >
        <FilesModal
          ref={fileModalChildRef}
          errorData={''}
          messageData={''}
          filesData={[]}
          isOTR={true}
          orderId={selectedOrder && selectedOrder.id}
        />
      </DataDialog>
      <ConfirmationDialog
        open={isDeleteOrderDialogOpen}
        title={'Delete Order'}
        isProcessing={isProcessing}
        toast={toast}
        handleConfirm={processDeleteOrder}
        handleCancel={() => closeDeleteOrderDialog(false)}
        handleCloseFunc={() => closeDeleteOrderDialog(false)}
      >
        <Typography variant='subtitle2'>{`Delete Order: ${selectedOrder && selectedOrder.loadId} `}</Typography>
        <Typography variant='body2' color={colors.error.main}>Order delete will delete associated legs, expenses, driver charges, invoices and bills.</Typography>
        <Typography variant='subtitle2' style={{ marginTop: '15px', textAlign: 'center' }}>{'Do you want to continue ?'}</Typography>
      </ConfirmationDialog>
    </Page>
  );
};

function mapStatesToProps(state) {
  // // Whatever is returned will show up as props inside of Orders
  const { orders, searched, order, isProcessing, toast } = state.otrOrderReducer;
  return {
    orders,
    searched,
    activeOrder: order,
    isProcessing,
    toast
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(OTROrderAction, dispatch);
}

export default connect(mapStatesToProps, mapDispatchToProps)(OTRDispatch);